// extracted by mini-css-extract-plugin
export var bodyRow = "_gv-d";
export var cardColumns = "_gv-e";
export var ellipsesOverflow = "_gv-2";
export var flatBottomCorners = "_gv-3";
export var flatTopCorners = "_gv-4";
export var headerActionsDropdown = "_gv-f";
export var headerBottomRow = "_gv-c";
export var headerTopRow = "_gv-b";
export var orderDetailsWrapper = "_gv-0";
export var orderInfoContainer = "_gv-1";
export var productDetails = "_gv-9";
export var productImage = "_gv-5";
export var responsiveTable = "_gv-8";
export var shipmentContainer = "_gv-a";
export var tableBottomLeft = "_gv-6";
export var tableBottomRight = "_gv-7";